import React, { useContext, useEffect } from 'react';
import {
	Label,
	Step,
	StepContent,
	StepGroup,
	StepTitle
} from 'semantic-ui-react';
import { OperationsContext } from '../OperationsContext';
import SetupTab from './SetupTab';
import ClientAnalysisTab from './ClientAnalysisTab';
import ReviewTab from './ReviewTab';

const Renewal = () => {
	// context
	const {
		renewal,
		getRenewals,
		cleanUpRenewals,
		renewalStep,
		setRenewalStep
	} = useContext( OperationsContext );

	useEffect( () => {
		getRenewals();

		return () => {
			cleanUpRenewals();
		};
	}, [
		cleanUpRenewals,
		getRenewals
	] );

	if ( !renewal ) {
		return null;
	}

	return (
		<div>
			<StepGroup>
				<Step
					active={ renewalStep === 1 }
					onClick={ () => {
						setRenewalStep( 1 );
					}}>
					<Label
						circular
						color="blue"
					>
            1
					</Label>
					<StepContent>
						<StepTitle>&nbsp;Renewal Setup</StepTitle>
					</StepContent>
				</Step>
				<Step
					active={ renewalStep === 2 }
					onClick={ () => {
						setRenewalStep( 2 );
					}}
				>
					<Label
						circular
						color="blue"
					>
            2
					</Label>
					<StepContent>
						<StepTitle>&nbsp;Client Analysis</StepTitle>
					</StepContent>
				</Step>
				<Step
					active={ renewalStep === 3 }
					onClick={ () => {
						setRenewalStep( 3 );
					}}
				>
					<Label
						circular
						color="blue"
					>
            3
					</Label>
					<StepContent>
						<StepTitle>&nbsp;Review</StepTitle>
					</StepContent>
				</Step>
			</StepGroup>
			{
				renewalStep === 1
					? <SetupTab />
					: renewalStep === 2
						? <ClientAnalysisTab />
						: renewalStep === 3
							? <ReviewTab />
							: null
			}
		</div>
	);
};

export default Renewal;
